import { Input } from 'antd';
import { normalize } from './normalize';
import type { StringField } from './types';

/**
 * Plain single-line text. Trims on blur so the stored value is the value that
 * was displayed — no invisible trailing space that fails a Zod refinement at
 * the API boundary.
 */
export function TextField({ value, onChange, onBlur, ...rest }: StringField) {
  return (
    <Input
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={() => {
        if (typeof value === 'string') {
          const trimmed = normalize(value, ['trim']);
          if (trimmed !== value) onChange?.(trimmed);
        }
        onBlur?.();
      }}
      {...rest}
    />
  );
}
